import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox']

  connect() {
    this.storageKey = 'wedding-photo-guide-checkbox-state'
    const savedState = localStorage.getItem(this.storageKey)
    this.state = savedState ? JSON.parse(savedState) : {}

    this.checkboxTargets.forEach(target => {
      const name = target.name
      if (this.state.hasOwnProperty(name)) {
        target.checked = this.state[name]
      }
    })
  }

  onChange(event) {
    const checkbox = event.currentTarget
    const name = checkbox.name
    const checked = checkbox.checked

    this.state[name] = checked
    localStorage.setItem(this.storageKey, JSON.stringify(this.state))
 
    this.checkboxTargets
      .filter(target => target.name === name )
      .forEach(target => { target.checked = checked })
  }
}
